<template>
	<div @click="$sidebar.displaySidebar(false)">
		<div class="row">
            <div class="col-xl-8 mb-0 mb-xl-0">
                <div class="card shadow">
                    <div class="card-body">
						<h4 class="mb-3">カテゴリー別ユーザー数（合計有効ユーザー数：{{ total }}人）</h4>
                         <div class="el-table__body-wrapper table-responsive">
							<table class='table table-striped el-table__body ' v-if="!loading">
								<thead>
									<tr class="el-table__row">
										<th scope="col">カテゴリー</th>
										<th scope="col">有効ユーザー数</th>  
									</tr>
								</thead>
								<tbody>
									<tr v-for="(category, key) in categories" :key="key" class="el-table__row">
										<td class="el-table_1_column_1"> {{ category.category_label }}</td>
										<td  class="el-table_1_column_2"> {{ category.cnt }} </td>
									</tr>
								</tbody>
							</table>    
                    	</div>
					</div>
                </div>
            </div>
            
        </div>
		<div class="row">
            <div class="col-xl-8 mb-5 mb-xl-0">
                <div class="card shadow">
                    <div class="card-body"> 
                    
						<div class="subscriber-details">
							<h4>日別ユーザー数</h4>
							<div class="year-month">
								<ul>
									<li class="dropdown-content">
										<select id="year" class="year" @change="onYearChange">
											
											<option v-for="(year,key) in years" :value="year" :selected="selectedYear === year" :key="key">{{ year }}年</option>
											</select>
									</li>
									<li class="dropdown-content">
										<select id="month" class="month" @change="onMonthChange">
											<option v-for="(month,key) in months" :value="month" :selected="selectedMonth === month" :key="key">{{ month }}月</option>
											</select>
									</li>
									<li> 
									<button
										:disabled="loading"
										@click="getSubscriptionSummary"
										type="button" class="btn btn-primary btn-send">
										適用する
									</button>
								
									</li>
								</ul>
							</div>
						</div>


        


        <div class="loading"  v-show="loading">受信中...</div>
		<div class="el-table__body-wrapper table-responsive">
	    <table class='table table-striped el-table__body' v-if="!loading">
		  	<thead>
		    	<tr class="el-table__row">
			    	<th scope="col">日付</th>
			     	<th scope="col">新規ユーザー数</th>
			     	<th scope="col">配信停止ユーザー数</th>
					<th scope="col">有効ユーザー数</th>
			      
		    	</tr>
		  	</thead>
			<tbody>

			<tr v-for="(subscriber, key) in subscriberList.data" :key="key" class="el-table__row">
					 <td class="el-table_1_column_1"> {{ formatToLocal(subscriber.date) }} </td>
			       	<td  class="el-table_1_column_2"> {{ subscriber.enable }} </td>
			        <td  class="el-table_1_column_3"> {{ subscriber.disable }} </td>
					<td  class="el-table_1_column_3"> {{ subscriber.active_cnt }} </td>
			        <!-- <td  class="el-table_1_column_4"> -- </td> -->
			        
			        
				</tr>
			
	  		</tbody>
	  	</table>
		</div>
		
	</div>
	
                </div>
            </div>
            
        </div>
		</div>
</template>
<script>

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import Chart from "chart.js";
import { Line, mixins } from 'vue-chartjs'
//const { reactiveProp } = mixins



export default {
 	extends: Line,
 //	mixins: [reactiveProp],
	components: {  Chart,  moment},
	props: ['categoryData'],
	data() {
		return {
			// Our data object that holds the Laravel paginator data
			subscriberList: {},
			siteId:0,
			total:null,
			categories:null,
			yearMonth:"",
			selectedMonth:null,
			selectedYear:null,
			loading:false,
			datacollection: null,
			barChart: {
				options:{
				    scales: {
				        xAxes: [{
				            barPercentage: 0.5,
				            barThickness: 6,
				            maxBarThickness: 8,
				            minBarLength: 2,
				            gridLines: {
				                offsetGridLines: true
				            }
				        }]
				    }
				},
				data:null
			}
			
		}
	},
	
	filters: {
    moment
  },
  computed : {
    years () {
      const year = new Date().getFullYear()
      return Array.from({length: year - 2018}, (value, index) => 2019 + index)
    },
    
    months () {
      return Array.from({length: 12}, (value, index) => 1 + index)
    }
  },
	mounted() {
		// Fetch initial results
		this.getResults();
		this.initializeSelection();
		this.fillData();
		this.categories= JSON.parse(this.categoryData);
		this.siteId = window.PushL.site_id
	},
	

	methods: {
	
		fillData () {
			this.datacollection = {
			labels: [this.getRandomInt(), this.getRandomInt()],
			datasets: [
				{
				label: 'Data One',
				backgroundColor: '#f87979',
				data: [this.getRandomInt(), this.getRandomInt()]
				}, {
				label: 'Data One',
				backgroundColor: '#f87979',
				data: [this.getRandomInt(), this.getRandomInt()]
				}
			]
			}
		},
		getRandomInt () {
			return Math.floor(Math.random() * (50 - 5 + 1)) + 5
		},
		initializeSelection () {
			this.selectedMonth = new Date().getMonth() + 1;
			this.selectedYear = new Date().getFullYear();
		},
		onMonthChange(event) {
			this.selectedMonth = parseInt(event.target.value);
		},
		onYearChange(event) {
			this.selectedYear = parseInt(event.target.value);
		},
			formatToLocal(date) {
			return moment.utc(date).local().format('YYYY年MM月DD日');
			// return moment(date).isSame(moment().clone().startOf('day'), 'd');
		},
		// Our method to GET results from a Laravel endpoint
		getResults() {
			this.siteId = window.PushL.site_id
			if(!this.selectedYear || !this.selectedMonth) {
				this.initializeSelection();
			}
			
			axios.get('/subscribers/' + this.siteId + '/getsubscritionsummary/'+ this.selectedYear + '/' + this.selectedMonth)
				.then(response => {
					this.subscriberList = response.data;
					this.total = response.data.total;
					this.loading = false;
					
				});
		},
		getPercentage(subscriber) {
			//
		},
		getSubscriptionSummary () {
		this.loading = true;
			this.getResults();
		}
	}
}
</script>
<style scoped>
    p {
    	text-align: center;
    }
    p span{
        font-weight:bold;
        padding: 0 5px;
    	font-size: 4em;
    }
	
	.subscriber-details h4 {
		display:inline-block;
		margin: 16px 0 0 0;
	}
	.subscriber-details .year-month {
		display:inline-block;
		float:right;
	}
    ul {
    float:left;
    padding:0;
    }
    li {
	float: left;
	margin: 5px 10px;
    }
    .year-month span {
	    display: inline-block;
	    float: left;
	    padding: 10px 30px;
    }
	
	select.year {
		width: 80px;
	}
	select.month {
		width: 60px;
	}
    select {
	height:36px;
	font-size: 13px;
	border-radius:4px;
	margin-top:4px;
	padding: 0 7px;
	background-position-x: 100%;
	background-position-y:7px;
	margin-right:0;
    }
    .loading {
        padding-top: 150px;
         padding-bottom: 150px;
	    font-size: 1.3em;
    }
    thead {
        background-color: #f8f9fe;
    	color: #181818;
    }
   
    
</style>